const ThemeEvents = Object.freeze({ cartUpdate: 'cart:update' });







class EcomMindsHeader extends HTMLElement {



  constructor() {



    super();



    this.abortController = new AbortController();



    this.openItem = null;



    this.cart = null;



    this.cartRequest = null;



  }







  connectedCallback() {



    const signal = this.abortController.signal;







    this.querySelectorAll('[data-em-nav-item]').forEach((item) => {



      const trigger = item.querySelector('[data-em-nav-trigger]');



      const panel = item.querySelector('[data-em-mega-panel]');



      if (!trigger || !panel) return;







      let closeTimer;







      const open = () => {



        window.clearTimeout(closeTimer);



        if (this.openItem && this.openItem !== item) this.closeMega(this.openItem);



        item.classList.add('is-open');



        trigger.setAttribute('aria-expanded', 'true');



        this.openItem = item;



      };







      const closeSoon = () => {



        closeTimer = window.setTimeout(() => this.closeMega(item), 120);



      };







      item.addEventListener('mouseenter', open, { signal });



      item.addEventListener('mouseleave', closeSoon, { signal });



      trigger.addEventListener('focus', open, { signal });



      item.addEventListener(



        'focusout',



        (event) => {



          if (!item.contains(event.relatedTarget)) closeSoon();



        },



        { signal }



      );



    });







    this.querySelectorAll('[data-em-search-open]').forEach((button) => {



      button.addEventListener('click', () => this.openSearch(), { signal });



    });







    this.querySelectorAll('[data-em-search-close]').forEach((button) => {



      button.addEventListener('click', () => this.closeSearch(), { signal });



    });







    this.querySelector('[data-em-mobile-open]')?.addEventListener('click', () => this.toggleMobile(), { signal });



    this.querySelector('[data-em-mobile-drawer]')?.addEventListener('click', this.onMobileDrawerClick, { signal });







    this.querySelectorAll('[data-em-cart-open]').forEach((button) => {



      button.addEventListener('click', () => this.openCart(), { signal });



    });







    this.querySelectorAll('[data-em-cart-close]').forEach((button) => {



      button.addEventListener('click', () => this.closeCart(), { signal });



    });







    this.querySelector('[data-em-cart-body]')?.addEventListener('click', this.onCartBodyClick, { signal });







    this.querySelector('[data-em-discount-apply]')?.addEventListener('click', this.applyDiscount, { signal });



    this.querySelector('[data-em-discount-input]')?.addEventListener(



      'keydown',



      (event) => {



        if (event.key === 'Enter') {



          event.preventDefault();



          this.applyDiscount();



        }



      },



      { signal }



    );







    this.querySelector('[data-em-terms-checkbox]')?.addEventListener('change', this.onTermsChange, { signal });



    this.querySelector('[data-em-checkout]')?.addEventListener('click', this.onCheckout, { signal });







    document.addEventListener(ThemeEvents.cartUpdate, this.onNativeCartUpdate, { signal });



    window.addEventListener('pageshow', this.onPageShow, { signal });



    window.addEventListener('resize', this.syncMobileMenuOffset, { signal });







    document.addEventListener(



      'keydown',



      (event) => {



        if (event.key !== 'Escape') return;



        this.closeSearch();



        this.closeMobile();



        this.closeCart();



        if (this.openItem) this.closeMega(this.openItem);



      },



      { signal }



    );







    this.refreshCart(false);



    this.syncMobileMenuOffset();



    this.initCartBenefits();



  }







  disconnectedCallback() {



    this.abortController.abort();



    if (this.cartBenefitTimer) window.clearInterval(this.cartBenefitTimer);



  }







  closeMega(item) {



    const trigger = item?.querySelector('[data-em-nav-trigger]');



    item?.classList.remove('is-open');



    trigger?.setAttribute('aria-expanded', 'false');



    if (this.openItem === item) this.openItem = null;



  }







  onNativeCartUpdate = async (event) => {



    const resource = event.detail?.resource;



    const source = event.detail?.data?.source;







    // ProductFormComponent fetches /cart.js before dispatching cart:update.



    // Therefore resource.item_count is the authoritative TOTAL.



    if (resource && typeof resource.item_count === 'number') {



      this.cart = resource;



      this.renderCartCount(resource.item_count);







      if (!this.querySelector('[data-em-cart-drawer]')?.hidden) {



        this.renderCartDrawer(resource);



      }







      if (source === 'product-form-component' && !event.detail?.data?.didError) {



        this.showCart();



        this.renderCartDrawer(resource);



      }



      return;



    }







    // CartItemsComponent sends the new total in data.itemCount.



    if (source === 'cart-items-component' && typeof event.detail?.data?.itemCount === 'number') {



      this.renderCartCount(event.detail.data.itemCount);



    }







    // Fallback for any other cart updater.



    const cart = await this.refreshCart(true);







    if (source === 'product-form-component' && !event.detail?.data?.didError && cart) {



      this.showCart();



    }



  };







  onPageShow = () => {



    this.refreshCart(false);



  };







  async fetchCart() {



    if (this.cartRequest) return this.cartRequest;







    this.cartRequest = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {



      method: 'GET',



      headers: { Accept: 'application/json' },



      credentials: 'same-origin',



    })



      .then((response) => {



        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);



        return response.json();



      })



      .finally(() => {



        this.cartRequest = null;



      });







    return this.cartRequest;



  }







  async refreshCart(renderDrawer = true) {



    try {



      const cart = await this.fetchCart();



      this.cart = cart;



      this.renderCartCount(cart.item_count || 0);



      if (renderDrawer || !this.querySelector('[data-em-cart-drawer]')?.hidden) {



        this.renderCartDrawer(cart);



      }



      return cart;



    } catch (error) {



      console.error('[EcomMinds Header] cart refresh failed', error);



      return null;



    }



  }







  renderCartCount(count) {



    this.querySelectorAll('[data-em-cart-count]').forEach((node) => {



      node.textContent = count < 100 ? String(count) : '99+';



      node.classList.toggle('is-hidden', count === 0);



      if (count > 0) {



        node.classList.remove('is-bumping');



        void node.offsetWidth;



        node.classList.add('is-bumping');



      }



    });







    this.querySelectorAll('[data-em-drawer-count]').forEach((node) => {



      node.textContent = String(count);



    });



  }







  money(cents, currency = this.cart?.currency || window.Shopify?.currency?.active || 'TRY') {



    try {



      return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {



        style: 'currency',



        currency,



      }).format((Number(cents) || 0) / 100);



    } catch (_) {



      return `${((Number(cents) || 0) / 100).toFixed(2)} ${currency}`;



    }



  }







  escapeHtml(value = '') {



    const div = document.createElement('div');



    div.textContent = String(value);



    return div.innerHTML;



  }







  renderCartDrawer(cart) {



    const body = this.querySelector('[data-em-cart-body]');



    const footer = this.querySelector('[data-em-cart-footer]');



    const subtotal = this.querySelector('[data-em-cart-subtotal]');



    if (!body || !footer || !subtotal) return;







    this.renderCartCount(cart.item_count || 0);







    if (!cart.items?.length) {



      const template = this.querySelector('[data-em-empty-cart-template]');



      body.innerHTML = template?.innerHTML || `<div class="em-cart-drawer__empty">Sepetiniz şu anda boş.</div>`;



      footer.hidden = true;



      return;



    }







    body.innerHTML = cart.items



      .map((item, index) => {



        const image = item.image



          ? `<a class="em-cart-line__image-wrap" href="${item.url}">



               <img class="em-cart-line__image" src="${item.image}" alt="${this.escapeHtml(item.product_title)}" loading="lazy">



             </a>`



          : `<a class="em-cart-line__image-wrap" href="${item.url}"></a>`;







        const variant =



          item.variant_title && item.variant_title !== 'Default Title'



            ? `<div class="em-cart-line__variant">${this.escapeHtml(item.variant_title)}</div>`



            : '';







        const cartHasDiscount = Number(item.original_line_price || 0) > Number(item.final_line_price || 0);



        const priceHtml = cartHasDiscount



          ? `<span class="em-cart-line__price is-sale"



                   data-em-cart-price



                   data-variant-id="${item.variant_id}"



                   data-product-handle="${this.escapeHtml(item.handle || '')}"



                   data-quantity="${item.quantity}"



                   data-final-line-price="${item.final_line_price}">



               <s class="em-cart-line__compare-price">${this.money(item.original_line_price, cart.currency)}</s>



               <strong class="em-cart-line__sale-price">${this.money(item.final_line_price, cart.currency)}</strong>



             </span>`



          : `<span class="em-cart-line__price"



                   data-em-cart-price



                   data-variant-id="${item.variant_id}"



                   data-product-handle="${this.escapeHtml(item.handle || '')}"



                   data-quantity="${item.quantity}"



                   data-final-line-price="${item.final_line_price}">



               <span class="em-cart-line__current-price">${this.money(item.final_line_price, cart.currency)}</span>



             </span>`;







        return `



          <article class="em-cart-line" data-em-cart-line data-line="${index + 1}">



            ${image}



            <div class="em-cart-line__content">



              <a class="em-cart-line__title" href="${item.url}">



                ${this.escapeHtml(item.product_title)}



              </a>



              ${variant}



              <div class="em-cart-line__bottom">



                <div class="em-cart-line__qty" aria-label="Adet">



                  <button type="button" data-em-cart-qty-minus data-line="${index + 1}" aria-label="Azalt">−</button>



                  <span>${item.quantity}</span>



                  <button type="button" data-em-cart-qty-plus data-line="${index + 1}" aria-label="Artır">+</button>



                </div>



                ${priceHtml}



              </div>



            </div>



            <button



              type="button"



              class="em-cart-line__remove"



              data-em-cart-remove



              data-line="${index + 1}"



              aria-label="Ürünü kaldır"



            >



              <svg viewBox="0 0 24 24" aria-hidden="true">



                <path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>



              </svg>



            </button>



          </article>



        `;



      })



      .join('');







    subtotal.textContent = this.money(cart.total_price, cart.currency);



    footer.hidden = false;







    // Product compare-at is not reliably present in /cart.js.



    // Hydrate it after the cart itself is rendered so the drawer remains responsive.



    this.hydrateCompareAtPrices(cart);



  }







  async hydrateCompareAtPrices(cart) {



    const priceNodes = Array.from(this.querySelectorAll('[data-em-cart-price]'));



    if (!priceNodes.length) return;







    const handles = [...new Set(



      priceNodes.map((node) => node.dataset.productHandle).filter(Boolean)



    )];



    if (!handles.length) return;







    const root = window.Shopify?.routes?.root || '/';



    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;



    const products = new Map();







    await Promise.all(



      handles.map(async (handle) => {



        try {



          const response = await fetch(



            `${normalizedRoot}products/${encodeURIComponent(handle)}.js`,



            { credentials: 'same-origin', headers: { Accept: 'application/json' } }



          );



          if (!response.ok) return;



          products.set(handle, await response.json());



        } catch (error) {



          console.warn('[EcomMinds Header] compare-at fetch failed', handle, error);



        }



      })



    );







    priceNodes.forEach((node) => {



      const product = products.get(node.dataset.productHandle);



      const variantId = Number(node.dataset.variantId || 0);



      const quantity = Math.max(1, Number(node.dataset.quantity || 1));



      const finalLinePrice = Number(node.dataset.finalLinePrice || 0);



      const variant = product?.variants?.find((entry) => Number(entry.id) === variantId);



      if (!variant) return;







      const compareAtUnit = Number(variant.compare_at_price || 0);



      const compareAtLine = compareAtUnit * quantity;



      if (!compareAtUnit || compareAtLine <= finalLinePrice) return;







      node.classList.add('is-sale');



      node.innerHTML = `



        <s class="em-cart-line__compare-price">${this.money(compareAtLine, cart.currency)}</s>



        <strong class="em-cart-line__sale-price">${this.money(finalLinePrice, cart.currency)}</strong>



      `;



    });



  }







  onCartBodyClick = async (event) => {



    const button = event.target.closest('[data-em-cart-qty-minus], [data-em-cart-qty-plus], [data-em-cart-remove]');



    if (!button) return;







    const line = Number(button.dataset.line);



    if (!line || !this.cart?.items?.[line - 1]) return;







    const item = this.cart.items[line - 1];



    let quantity = item.quantity;







    if (button.hasAttribute('data-em-cart-remove')) quantity = 0;



    if (button.hasAttribute('data-em-cart-qty-minus')) quantity = Math.max(0, quantity - 1);



    if (button.hasAttribute('data-em-cart-qty-plus')) quantity += 1;







    button.disabled = true;







    try {



      const root = window.Shopify?.routes?.root || '/';



      const response = await fetch(`${root}cart/change.js`, {



        method: 'POST',



        headers: {



          'Content-Type': 'application/json',



          Accept: 'application/json',



        },



        credentials: 'same-origin',



        body: JSON.stringify({ line, quantity }),



      });







      if (!response.ok) throw new Error(`Cart change failed: ${response.status}`);







      const cart = await response.json();



      this.cart = cart;



      this.renderCartCount(cart.item_count || 0);



      this.renderCartDrawer(cart);







      // Let the rest of the theme know the cart changed.



      document.dispatchEvent(



        new CustomEvent(ThemeEvents.cartUpdate, {



          bubbles: true,



          detail: {



            data: {



              itemCount: cart.item_count,



              source: 'ecomminds-header',



            },



          },



        })



      );



    } catch (error) {



      console.error('[EcomMinds Header] cart change failed', error);



      await this.refreshCart(true);



    }



  };







  async openCart() {



    this.closeMobile();



    this.closeSearch();



    this.showCart();



    await this.refreshCart(true);



  }







  showCart() {



    const drawer = this.querySelector('[data-em-cart-drawer]');



    if (!drawer) return;



    drawer.hidden = false;



    this.lockPage(true);



  }







  closeCart() {



    const drawer = this.querySelector('[data-em-cart-drawer]');



    if (!drawer || drawer.hidden) return;



    drawer.hidden = true;



    this.lockPage(false);



  }







  onTermsChange = () => {



    const checkbox = this.querySelector('[data-em-terms-checkbox]');



    const checkout = this.querySelector('[data-em-checkout]');



    const error = this.querySelector('[data-em-terms-error]');



    const checked = checkbox ? checkbox.checked : true;







    if (checkout) checkout.setAttribute('aria-disabled', checked ? 'false' : 'true');



    if (checked && error) error.hidden = true;



  };







  onCheckout = (event) => {



    event?.preventDefault();







    const checkbox = this.querySelector('[data-em-terms-checkbox]');



    const error = this.querySelector('[data-em-terms-error]');







    if (checkbox && !checkbox.checked) {



      if (error) error.hidden = false;



      checkbox.focus();



      return;



    }







    const root = window.Shopify?.routes?.root || '/';



    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;



    window.location.href = `${normalizedRoot}checkout`;



  };







  applyDiscount = async () => {



    const input = this.querySelector('[data-em-discount-input]');



    const button = this.querySelector('[data-em-discount-apply]');



    const status = this.querySelector('[data-em-discount-status]');



    if (!input || !button || !status) return;







    const code = input.value.trim();



    status.classList.remove('is-success', 'is-error');







    if (!code) {



      status.textContent = 'Lütfen bir indirim kodu girin.';



      status.classList.add('is-error');



      return;



    }







    button.disabled = true;



    try {



      const root = window.Shopify?.routes?.root || '/';



      const normalizedRoot = root.endsWith('/') ? root : `${root}/`;



      const response = await fetch(`${normalizedRoot}discount/${encodeURIComponent(code)}?redirect=/cart.js`, {



        credentials: 'same-origin',



        headers: { Accept: 'application/json' },



      });







      if (!response.ok) throw new Error(`Discount failed: ${response.status}`);







      status.textContent = 'İndirim kodu uygulandı.';



      status.classList.add('is-success');



      await this.refreshCart(true);



    } catch (error) {



      console.error('[EcomMinds Header] discount failed', error);



      status.textContent = 'İndirim kodu uygulanamadı.';



      status.classList.add('is-error');



    } finally {



      button.disabled = false;



    }



  };







  lockPage(locked) {



    document.documentElement.classList.toggle('em-header-lock', locked);



    document.body.classList.toggle('em-header-lock', locked);



  }







  openSearch() {



    this.closeMobile();



    this.closeCart();



    const overlay = this.querySelector('[data-em-search-overlay]');



    if (!overlay) return;



    overlay.hidden = false;



    this.lockPage(true);



    requestAnimationFrame(() => overlay.querySelector('[data-em-search-input]')?.focus());



  }







  closeSearch() {



    const overlay = this.querySelector('[data-em-search-overlay]');



    if (!overlay || overlay.hidden) return;



    overlay.hidden = true;



    this.lockPage(false);



  }







  onMobileDrawerClick = (event) => {



    const navButton = event.target.closest('[data-em-mobile-nav-to]');



    if (navButton) {



      const target = navButton.getAttribute('data-em-mobile-nav-to');



      if (target) this.openMobileView(target);



      return;



    }







    const backButton = event.target.closest('[data-em-mobile-back]');



    if (backButton) this.openMobileView('root', true);



  };







  openMobileView(name, returning = false) {



    const drawer = this.querySelector('[data-em-mobile-drawer]');



    if (!drawer) return;







    const views = Array.from(drawer.querySelectorAll('[data-em-mobile-view]'));



    const target = views.find((view) => view.getAttribute('data-em-mobile-view') === name);



    if (!target) return;







    views.forEach((view) => {



      view.classList.remove('is-active', 'is-entering', 'is-returning');



      view.hidden = view !== target;



    });







    target.hidden = false;



    target.scrollTop = 0;



    target.classList.add('is-active', returning ? 'is-returning' : 'is-entering');







    window.setTimeout(() => target.classList.remove('is-entering', 'is-returning'), 260);



  }







  resetMobileView() {



    this.openMobileView('root', true);



  }







  syncMobileMenuOffset = () => {



    const mobileHeader = this.querySelector('.em-header__mobile');



    if (!mobileHeader || getComputedStyle(mobileHeader).display === 'none') return;







    const rect = mobileHeader.getBoundingClientRect();



    const top = Math.max(0, Math.round(rect.bottom));



    this.style.setProperty('--em-mobile-menu-top', `${top}px`);



  };







  toggleMobile() {



    const drawer = this.querySelector('[data-em-mobile-drawer]');



    if (!drawer) return;



    if (drawer.hidden) this.openMobile();



    else this.closeMobile();



  }







  openMobile() {



    this.closeSearch();



    this.closeCart();



    const drawer = this.querySelector('[data-em-mobile-drawer]');



    if (!drawer) return;







    this.syncMobileMenuOffset();



    drawer.hidden = false;



    this.openMobileView('root');







    const button = this.querySelector('[data-em-mobile-open]');



    button?.setAttribute('aria-expanded', 'true');







    this.lockPage(true);



  }







  closeMobile() {



    const drawer = this.querySelector('[data-em-mobile-drawer]');



    if (!drawer || drawer.hidden) return;



    drawer.hidden = true;



    this.resetMobileView();







    const button = this.querySelector('[data-em-mobile-open]');



    button?.setAttribute('aria-expanded', 'false');







    this.lockPage(false);



  }



}







if (!customElements.get('ecomminds-header')) {



  customElements.define('ecomminds-header', EcomMindsHeader);



}
